import { render, staticRenderFns } from "./VerticalSingleBar.vue?vue&type=template&id=871f95e8&"
import script from "./VerticalSingleBar.vue?vue&type=script&lang=ts&"
export * from "./VerticalSingleBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports